import React, { useState } from 'react';
import '../../css/modal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (paymentData: {
    amount: number;
    method: string;
    transactionId: string;
    notes?: string;
  }) => void;
  defaultAmount?: number;
  totalPrice?: number;
  paidAmount?: number;
}

const AddPaymentModal: React.FC<Props> = ({ isOpen, onClose, onSubmit, defaultAmount, totalPrice, paidAmount }) => {
  const balanceAmount = totalPrice && paidAmount ? totalPrice - paidAmount : (defaultAmount || 0);
  const [amount, setAmount] = useState(balanceAmount);
  const [method, setMethod] = useState('cash');
  const [transactionId, setTransactionId] = useState('');
  const [notes, setNotes] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ amount, method, transactionId, notes });
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>×</button>
        <h3>Add Payment</h3>
        {totalPrice && paidAmount !== undefined && (
          <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '4px' }}>
            <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Balance Payment</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827' }}>
              ₹{paidAmount.toLocaleString('en-IN')} / ₹{totalPrice.toLocaleString('en-IN')}
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit} className="form">
          <label>
            Amount:
            <input type="number" value={amount} onChange={e => setAmount(+e.target.value)} required min="0" step="0.01" />
          </label>

          <label>
            Payment Method:
            <select value={method} onChange={e => setMethod(e.target.value)} required>
              <option value="cash">Cash</option>
              <option value="cheque">Cheque</option>
              <option value="online">Online</option>
            </select>
          </label>

          <label>
            Transaction ID / Reference:
            <input 
              type="text" 
              value={transactionId} 
              onChange={e => setTransactionId(e.target.value)} 
              placeholder="Enter transaction ID / reference"
              required
            />
          </label>

          <label>
            Notes:
            <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Additional notes (optional)" />
          </label>

          <button type="submit" className="primary-btn">Capture Payment</button>
        </form>
      </div>
    </div>
  );
};

export default AddPaymentModal;
